import { render, staticRenderFns } from "./ECatalogueLayout.vue?vue&type=template&id=94d3ba52"
import script from "./ECatalogueLayout.vue?vue&type=script&lang=js"
export * from "./ECatalogueLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports